export const AttendanceRequestPaths = {
  MANAGE_REQUEST_ATTENDANCE_REQUEST: 'attendance-request',
  MANAGE_REQUEST_CREATE_ATTENDANCE_REQUEST: 'create',
  MANAGE_REQUEST_EDIT_ATTENDANCE_REQUEST: 'edit/:requestId',
};
